import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import Footer from "../pallet/Footer";
import AssetQuantityField from "../../../../views/inventory/requests/AssetQuantityField";
import QuantitySelectionModal from "./QuantitySelectionModal";

const styles = {
  button: {
    minWidth: 100,
  },
};

export default function Step2({ onBack, onMoveToMultipleLocations, quantity }) {
  const [value, setValue] = useState(0);
  const [showQuantityModal, setShowQuantityModal] = useState(false);

  const handleNext = () => {
    const locationQuantity = quantity / value;

    if (value === 1) {
      onMoveToMultipleLocations(value, quantity);
    } else if (locationQuantity % 1 !== 0) {
      onMoveToMultipleLocations(value, 0);
    } else {
      setShowQuantityModal(true);
    }
  };

  const handleDifferentQuantities = () => {
    onMoveToMultipleLocations(value, 0);
    setShowQuantityModal(false);
  };

  const handleSameQuantities = () => {
    onMoveToMultipleLocations(value, quantity / value);
    setShowQuantityModal(false);
  };

  return (
    <>
      <DialogContent>
        <Box textAlign="center" mb={3} minHeight={300} display="flex" alignItems="center">
          <Box width="100%">
            <Typography color="textPrimary" mb={4}>
              How many new locations are we moving into?
            </Typography>
            <Box mt={4}>
              <AssetQuantityField
                quantity={value}
                onChange={setValue}
                size="large"
                quantityProps={{
                  label: "# of New Locations",
                  style: { minWidth: 160 },
                  InputLabelProps: {
                    shrink: true,
                  },
                  autoFocus: true,
                }}
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <Footer step={2}>
        <Box />
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={onBack} sx={styles.button}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            disabled={!value}
            sx={styles.button}
          >
            Next
          </Button>
        </Box>
      </Footer>
      <QuantitySelectionModal
        open={showQuantityModal}
        onClose={() => setShowQuantityModal(false)}
        onSelectSameQuantities={handleSameQuantities}
        onSelectDifferentQuantities={handleDifferentQuantities}
        quantity={quantity / value}
      />
    </>
  );
}
